import React from 'react';
import { Alert, Button, Modal, Table, Typography } from 'antd';
import dayjs from 'dayjs';
import { LIMITE_COMPONENTES_POR_GRUPO, calcularValorTotalVisual, limitarSugestaoATeto } from './cobrancasEventosAcoes';

// Fase D.3 -- modal de REVISAO/CONFIRMACAO antes de formar um
// FinancialChargeGroup. Componente "burro" (Secao 5 da instrucao):
// zero HTTP proprio, zero estado de rede -- so' apresenta `sugestao`
// (vinda de `indexarSugestaoConsolidacao`, ja' calculada em
// CobrancasEventosAdmin.js) e delega a confirmacao para `onConfirmar`.
//
// REGRA DE UX FECHADA (Secao 3 da instrucao original D.3/D.4, mantida
// nesta fase): este modal SOMENTE forma o grupo -- nunca emite o
// boleto consolidado. O texto e o botao sao deliberadamente distintos
// de "Consolidar e emitir" para nunca sugerir uma operacao unica.
//
// `data_vencimento` chega como "YYYY-MM-DD" -- mesmo padrao de
// dayjs(...) direto sobre a string ja usado em CobrancasEventosAdmin.js
// (nunca `new Date(...)`, evita deslocamento de fuso).
const formatarDataBR = (dataIso) => (dataIso ? dayjs(dataIso).format('DD/MM/YYYY') : '—');

const formatarValorBRL = (valorDecimalString) => {
  const numero = Number(valorDecimalString);
  if (Number.isNaN(numero)) return '—';
  return `R$ ${numero.toFixed(2).replace('.', ',')}`;
};

const ConsolidarCobrancasModal = ({ open, sugestao, emAndamento, onConfirmar, onFechar }) => {
  const { componentesExibidos, restante } = limitarSugestaoATeto(
    sugestao?.componentes,
    LIMITE_COMPONENTES_POR_GRUPO
  );
  const primeiro = componentesExibidos[0];

  const handleFechar = () => {
    if (emAndamento) {
      // POST em andamento -- nunca fecha (mesmo principio dos demais
      // modais desta tela: evita reabrir e disparar uma segunda
      // chamada antes da primeira responder).
      return;
    }
    onFechar();
  };

  const handleConfirmar = () => {
    onConfirmar(componentesExibidos.map((c) => c.financial_charge_id));
  };

  return (
    <Modal
      title="Consolidar cobranças"
      open={open}
      onCancel={handleFechar}
      closable={!emAndamento}
      maskClosable={!emAndamento}
      width={640}
      destroyOnClose
      footer={[
        <Button key="cancelar" onClick={handleFechar} disabled={emAndamento}>
          Cancelar
        </Button>,
        <Button key="confirmar" type="primary" loading={emAndamento} disabled={emAndamento} onClick={handleConfirmar}>
          Consolidar cobranças
        </Button>,
      ]}
    >
      {primeiro && (
        <>
          <Typography.Paragraph>
            <Typography.Text strong>{primeiro.aluno_nome || '—'}</Typography.Text>
            {' · '}
            Vencimento {formatarDataBR(primeiro.data_vencimento)}
          </Typography.Paragraph>

          <Table
            size="small"
            rowKey="financial_charge_id"
            dataSource={componentesExibidos}
            pagination={false}
            columns={[
              { title: 'Evento', dataIndex: 'evento_nome' },
              { title: 'Parcela', key: 'parcela', render: (_, c) => c.numero_parcela },
              {
                title: 'Valor',
                key: 'valor',
                align: 'right',
                render: (_, c) => formatarValorBRL(c.valor),
              },
            ]}
          />

          <Typography.Paragraph style={{ marginTop: 12, textAlign: 'right' }}>
            <Typography.Text strong>
              Total: {formatarValorBRL(calcularValorTotalVisual(componentesExibidos))}
            </Typography.Text>
          </Typography.Paragraph>

          {restante > 0 && (
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 12 }}
              message={`Mostrando ${componentesExibidos.length} de ${componentesExibidos.length + restante} cobranças compatíveis nesta página. As demais continuarão disponíveis para uma nova consolidação.`}
            />
          )}

          <Alert
            type="info"
            showIcon
            message="Será criado um único grupo para estas cobranças. A emissão do boleto será feita separadamente após a confirmação."
          />
        </>
      )}
    </Modal>
  );
};

export default ConsolidarCobrancasModal;
